import LocalState from '../../state/LocalState';
import Reporter from '../../common/Reporter/Reporter';
import handleWebsocketConnect from './handleWebsocketConnect';
import logger from '../../log';
import { ApiEvents } from '@kollective-frontend/ksdk-api';
import { EventData } from '../../common/interfaces';
const log = logger.getLogger(__filename);

const { WEBSOCKET_CONNECT } = ApiEvents;
type CoveredApiEvents = ApiEvents.WEBSOCKET_CONNECT;

export type DiagnosticBinderFunction = (
  e: EventData,
  state: LocalState
) => Promise<void>;

export const binders: Record<CoveredApiEvents, unknown> = {
  [WEBSOCKET_CONNECT]: handleWebsocketConnect
};

export default function bindDiagnosticListeners(reporter: Reporter): void {
  const { eventEmitter: emitter, localState: state } = reporter;
  Object.entries(binders).forEach(([key, f]) => {
    const func = f as DiagnosticBinderFunction;
    log.trace(`binding ${key} diagnostic listener`);
    emitter.addEventListener(key as ApiEvents, (e: EventData) =>
      func(e, state)
    );
  });
}
